export const adminRouteNames = [
  'adminOpportunities', 'adminOpportunity', 'adminOpportunityCreate', 'adminOpportunityDuplicate',
  'adminOpportunityTemplates', 'adminOpportunityTemplateForm', 'adminOpportunityTemplateFormEdit',
  'adminOpportunityRequests', 'adminOpportunityPhotos',
  'adminCommunications', 'adminMetrics', 'adminNonprofits', 'adminNonprofit',
]
